var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuejsColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1929",
    "data-name": "Rectangle 1929",
    width: 52,
    height: 52,
    transform: "translate(570 763)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    transform: "translate(-570 -763)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vue.js_Logo_2",
    transform: "translate(554.841 828.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15822",
    "data-name": "Group 15822",
    transform: "translate(15.159 -62.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19653",
    "data-name": "Path 19653",
    d: "M0,0-6,10.858-12.009,0H-32L-6,47.015,20,0Z",
    transform: "translate(32.004)",
    fill: "#41b883"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15823",
    "data-name": "Group 15823",
    transform: "translate(25.559 -62.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19654",
    "data-name": "Path 19654",
    d: "M0,0-6,10.4l-6-10.4h-9.6L-6,27.02,9.6,0Z",
    transform: "translate(21.604)",
    fill: "#34495e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuejsColored);
export default __webpack_public_path__ + "static/media/vuejs-colored.dd3c05aa53e017ea3e6dfbcfdc51bacf.svg";
export { ForwardRef as ReactComponent };